import { Component, Input } from '@angular/core';

import { ProductDetailViewModel } from '../../models/product-detail-view-model';
import { SellerPriceDetails } from '@usf/price-types';
import { ProductPropertiesEnum } from '@usf/product-types';

@Component({
  selector: 'app-seller-detail-description',
  templateUrl: './seller-detail-description.component.html',
  styleUrls: ['./seller-detail-description.component.scss'],
})
export class SellerDetailDescriptionComponent {
  @Input() sellerPriceDetail: SellerPriceDetails;
  @Input() product: ProductDetailViewModel;
  @Input() isPmeSgpEnabled: boolean;

  productEnum = ProductPropertiesEnum;

  constructor() {}
}
